export const texts = {
    packageTitle: "activation.package.title",
    manageButton: "activation.package.manage.button.text",
    tooltip: "activation.invite.teammates",
    upgradeButtonText: "trial_hook.duration.button.text",
    dayLeft: "growth.homepageTrial.layout.header.dayLeft",
    dayLeftCount: "growth.homepageTrial.layout.header.dayLeft",
};
